import { Stack } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { Path } from '../../models/navigation'
import { BOTTOM_NAVIGATION_HEIGHT, LayoutNavigation } from '../common/layout-navigation'

import { InternalPointsExchangeNutshell } from './internal-points-exchange-nutshell'

export const InternalPointsExchange: FC = () => {
  return (
    <LayoutNavigation stretchContentVertically backButtonPath={Path.Home}>
      <Stack
        paddingX={unit(3)}
        paddingBottom={unit(3 + BOTTOM_NAVIGATION_HEIGHT)}
        bgcolor={COLORS.white}
        minHeight='100%'
      >
        <InternalPointsExchangeNutshell />
      </Stack>
    </LayoutNavigation>
  )
}
